import { Component } from 'vue-mixin-decorator';
import AuthBaseVue from '@/views/auth.base.vue';
import ResultsConsole from '@/components/results/resultsConsole/resultsConsole.vue';
import store from '@/store';

/** GS-901 — the result console's page (signed-in operators only, where the environment requires sign-in). */
@Component({
  components: {
    ResultsConsole,
  },
})
export default class ResultsPage extends AuthBaseVue {
  private pageName = 'Results';
  private pageCode = 'RESULTS_PAGE';

  async created(): Promise<void> {
    store.dispatch('mainStore/setPageContext', { pageName: this.pageName, pageCode: this.pageCode, requireLogin: true });
  }

  mounted(): void {
    document.body.classList.add('rc-body');
    document.title = 'Results · Director';
  }

  beforeDestroy(): void {
    document.body.classList.remove('rc-body');
  }
}
